import moment from 'moment';
export function formatDateTime(value: Date | string | number | null | undefined): string {
	if (value === null || value === undefined) {
		return '-';
	}
	const m = moment(value);
	if (!m.isValid()) {
		return '-';
	}
	return m.format('DD.MM.YYYY HH:mm:ss');
}

export function formatUtcDateTime(value: Date | string | number | null | undefined): string {
	if (value === null || value === undefined) {
		return '-';
	}
	const m = moment.utc(value).local();
	if (!m.isValid()) {
		return '-';
	}
	return m.format('DD.MM.YYYY HH:mm:ss');
}

/** Parse a UTC timestamp. Strings without a timezone suffix are treated as UTC, not local. */
export function parseUtcDate(value: Date | string | number): Date {
	if (value instanceof Date) {
		return value;
	}
	return moment.utc(value).toDate();
}

export function formatDate(value: Date | string | number | null | undefined): string {
	if (value === null || value === undefined) {
		return '-';
	}
	const m = moment(value);
	if (!m.isValid()) {
		return '-';
	}
	return m.format('DD.MM.YYYY');
}

export function formatWith(value: Date | string | number | null | undefined, pattern: string): string {
	if (value === null || value === undefined) {
		return '-';
	}
	const m = moment(value);
	if (!m.isValid()) {
		return '-';
	}
	return m.format(pattern);
}

